import { ContractReviewState, ContractReviewUnloadState } from '../../states/ContractReview.States';
import * as actions from '../../actions/ContractReview.Actions';
import { updateFindings } from './ContractReview.Shared';

const withoutKey = <T,>(record: Record<number, T>, key: number): Record<number, T> => {
  const { [key]: _removed, ...rest } = record;
  return rest;
};

/**
 * Deshacer (spec 015; Contracts 021 §4): el de un hallazgo reemplaza el hallazgo con el que devuelve Contracts; el de
 * la revisión guarda el resultado. En ambos casos el middleware recarga el detalle, que trae estado y contadores.
 */
export default function ContractReviewUndoReducer(state: ContractReviewState | undefined, action: any): ContractReviewState {
  const current = state ?? ContractReviewUnloadState;
  switch (action.type) {
    case actions.CONTRACT_REVIEW_UNDO_FINDING_REQUEST:
      return {
        ...current,
        undoingFindingIds: [...current.undoingFindingIds.filter(id => id !== action.findingId), action.findingId],
        undoErrors: withoutKey(current.undoErrors, action.findingId)
      };
    case actions.CONTRACT_REVIEW_UNDO_FINDING_SUCCESS:
      return {
        ...current,
        undoingFindingIds: current.undoingFindingIds.filter(id => id !== action.findingId),
        byId: action.finding
          ? updateFindings(current.byId, action.reviewId, f => (f.id === action.findingId ? { ...f, ...action.finding } : f))
          : current.byId
      };
    case actions.CONTRACT_REVIEW_UNDO_FINDING_FAILURE:
      return {
        ...current,
        undoingFindingIds: current.undoingFindingIds.filter(id => id !== action.findingId),
        undoErrors: { ...current.undoErrors, [action.findingId]: action.error }
      };
    case actions.CONTRACT_REVIEW_UNDO_REQUEST:
      return { ...current, isUndoing: true, undoResult: undefined, undoError: undefined };
    case actions.CONTRACT_REVIEW_UNDO_SUCCESS:
      return { ...current, isUndoing: false, undoResult: action.result };
    case actions.CONTRACT_REVIEW_UNDO_FAILURE:
      return { ...current, isUndoing: false, undoError: action.error };
    case actions.CONTRACT_REVIEW_CLEAR_UNDO_RESULT:
      return { ...current, undoResult: undefined, undoError: undefined };
    default:
      return current;
  }
}
